import { render, staticRenderFns } from "./BetslipLock.vue?vue&type=template&id=680ef332&scoped=true"
import script from "./BetslipLock.vue?vue&type=script&lang=js"
export * from "./BetslipLock.vue?vue&type=script&lang=js"
import style0 from "./BetslipLock.vue?vue&type=style&index=0&id=680ef332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ef332",
  null
  
)

export default component.exports